<template>
    <div class="mailList">
        <div class="group-list">
            <div style="height:135px">
                 <div style="padding:0 24px">
                    <div>
                        <span style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold">通讯录</span>
                    </div>
                    <div style="position:relative;margin-top:19px;">
                        <a-icon style="position:absolute;top:9px;left:10px;z-index:10;color:rgba(158, 172, 196, 0.7)" type="search" />
                        <a-input v-model="searchName" @change='nameChange' placeholder="搜索姓名" style="width:100%;height:32px;padding-left:30px;" />
                    </div>
                </div>
                <div class="group-tab">
                    <a-row style="height:42px;">
                        <a-col :span="12" style="text-align:center">
                            <a-icon @click="selectTab(1)" :class="{'active':currentTab==1}" style="margin-left:30px" type="team" />
                        </a-col>
                        <a-col :span="12" style="text-align:center">
                            <a-icon @click="selectTab(2)" :class="{'active':currentTab==2}" style="margin-left:-30px" type="solution" />
                        </a-col>
                    </a-row>
                </div>
            </div>
            <div class="user-list">
                <div v-if="currentTab==1">
                    <div class="name-item" v-for="(item,index) in userTree.userList" :key='index'>
                        <div v-if="item.value==-1" class="name-title">
                            <a-icon style="" type="star" />
                            {{item.title}}
                        </div>
                        <div v-if="item.value==-1">
                            <div @click="selectUser(item1.value, true, item1.messageCount)" :class="{'active':selectedUser==item1.value&&commonContacts}" class="name-box" v-for="(item1,index1) in item.children" :key='index1'>
                                <span v-if="item1.avatar==''" class="name-abbreviation">{{item1.title.slice(0,1)}}</span>
                                <img v-if="item1.avatar!=''" class="name-img" :src="item1.avatar" alt="">
                                <span class="name-title">{{item1.title}}</span>
                                <a-icon @click="removeCollection(item1.value, false)" class="remove-icon" type="delete" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="name-item" v-for="(item,index) in userTree.userList" :key='index'>
                            <div v-if="item.value!=-1" class="name-title">
                                {{item.title}}
                            </div>
                            <div v-if="item.value!=-1">
                                <div @click="selectUser(item1.value, false, item1.messageCount)" :class="{'active':selectedUser==item1.value&&!commonContacts}" class="name-box" v-for="(item1,index1) in item.children" :key='index1'>
                                    <span v-if="item1.avatar==''" class="name-abbreviation">{{item1.title.slice(0,1)}}</span>
                                    <img v-if="item1.avatar!=''" class="name-img" :src="item1.avatar" alt="">
                                    <span class="name-title">{{item1.title}}</span>
                                    <a-icon v-if="item1.isLiaison==false" @click="addCollection(item1.value)" class="add-icon" type="star" />
                                    <span class="number-unread" v-if="item1.messageCount!=0">{{item1.messageCount}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="currentTab==2">
                    <a-tree :tree-data="userTree.serviceProviderUserList" default-expand-all @select="onSelect"></a-tree>
                </div>
            </div>
        </div>
        <div class="right-content">
            <div class="content-detail">
                <div class="user-info">
                    <div class="user-info-head">
                        <div style="padding-top:165px;">
                            <div v-if="userInfo.avatar==''" style="display:inline-block;width:96px;height:96px;border-radius:48px;background:#fff;text-align:center;padding-top:4px;position:absolute;bottom:-44px;left:16px;">
                                <span style="display:inline-block;width:88px;height:88px;border-radius:44px;background:#3ADCFF;line-height:88px;text-align:center;color:#fff;font-size:24px;">{{userInfo.name==undefined?'姓名':userInfo.name.substr(-2,2)}}</span>
                            </div>
                            <img v-if="userInfo.avatar!=''" :src="userInfo.avatar" style="display:inline-block;width:96px;height:96px;border-radius:48px;background:#fff;text-align:center;position:absolute;bottom:-44px;left:16px;" alt="">
                            <span style="padding-left:130px;color:rgba(18, 18, 18, 1);font-weight:bold;font-size:18px;">{{userInfo.name==undefined?'姓名':userInfo.name}}</span>
                            <a-icon @click="removeCollection(selectedUser, true)" v-if="userInfo.isLiaison" style="font-size:18px;color:rgba(158, 172, 196, 1);margin-left:12px;" type="star" />
                        </div>
                    </div>
                    <div class="user-info-foot">
                        <div style="padding-top:5px;display:inline-block">
                            <a-icon type="phone" />
                            <span>{{userInfo.phone==undefined?'手机号码':userInfo.phone}}</span>
                            <a-divider class="line" type="vertical" />
                            <a-icon type="reconciliation" />
                            <span>{{userInfo.serviceProviderName==undefined?'服务商名称':userInfo.serviceProviderName}}</span>
                            <a-divider class="line" type="vertical" />
                            <a-icon type="clock-circle" />
                            <span>{{userInfo.lastLoginTime==undefined?'最后登录时间':userInfo.lastLoginTime}}</span>
                        </div>
                    </div>
                </div>
                <div class="task-list">
                    <div class="task-content">
                        <div class="task-info">
                            <div style="width:100%;height:100%;display:flex;flex-direction:column">
                                <div class="task-head">
                                    <span :class="{'active':currentTask==1}" @click="selectTask(1)">我负责的任务</span>
                                    <span :class="{'active':currentTask==2}" @click="selectTask(2)">我创建的任务</span>
                                    <span :class="{'active':currentTask==3}" @click="selectTask(3)">我协同的任务</span>
                                    <span :class="{'active':currentTask==4}" @click="selectTask(4)" style="position:relative">我收到的消息
                                        <!-- <div class="unread-number" v-if="messageCount!=0"> {{messageCount}}</div> -->
                                       
                                    </span>
                                </div>
                                <div class="task-body">
                                    <div class="my-task" v-if="currentTask==1">
                                        <div class="item-task" v-for="(item,index) in taskObj.myResponseTask" :key='index'>
                                            <span class="task-state">{{item.statusName}}</span>
                                            <span class="task-title">{{item.dataTitle}}</span>
                                            <a-divider style="background:#B4BFD2;margin:0 12px" type="vertical" />
                                            <span class="relation-name">{{item.moduleName}}</span>
                                            <div class="right-item">
                                                <span class="time">{{item.beginTime}}  -  {{item.limitTime}}</span>
                                                <div class="tag-list">
                                                    {{item.label}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="created-task" v-if="currentTask==2">
                                        <div class="item-task" v-for="(item,index) in taskObj.myCreatedTask" :key='index'>
                                            <span class="task-state">{{item.statusName}}</span>
                                            <span class="task-title">{{item.dataTitle}}</span>
                                            <a-divider style="background:#B4BFD2;margin:0 12px" type="vertical" />
                                            <span class="relation-name">{{item.moduleName}}</span>
                                            <div class="right-item">
                                                <span class="time">{{item.beginTime}}  -  {{item.limitTime}}</span>
                                                <div class="tag-list">
                                                    {{item.label}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="coordination-task" v-if="currentTask==3">
                                        <div class="item-task" v-for="(item,index) in taskObj.myCoordinationTask" :key='index'>
                                            <span class="task-state">{{item.statusName}}</span>
                                            <span class="task-title">{{item.dataTitle}}</span>
                                            <a-divider style="background:#B4BFD2;margin:0 12px" type="vertical" />
                                            <span class="relation-name">{{item.moduleName}}</span>
                                            <div class="right-item">
                                                <span class="time">{{item.beginTime}}  -  {{item.limitTime}}</span>
                                                <div class="tag-list">
                                                    {{item.label}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="receive-msg" v-if="currentTask==4">
                                        <div class="receive-item" v-for="(item,index) in messageList" :key="index" style="cursor: pointer;" @click="viewDel(item.moduleId,item.dataId,item.id)">
                                            <span v-if="item.readStatus==2" class="receive-name1">已读</span>
                                            <span v-if="item.readStatus==1" class="receive-name2">未读</span>
                                            <div class="receive-content">
                                                <div class="receive-con1">{{convertToPlainText(item.content)}}</div>
                                                <div class="receive-con2">
                                                    <span>{{item.moduleName}}</span>
                                                    <span>{{item.createTime}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="personal-info" v-if="selectedUser!=''">
                            <div style="height:46px;border-bottom:1px solid rgba(229, 229, 229, 1);line-height:55px;color:rgba(58, 220, 255, 1);font-size:13px;font-weight:bold;">
                                <span style="display:inline-block;border-bottom:3px solid rgba(58, 220, 255, 1);line-height:30px;">个人信息</span>
                            </div>
                            <div class="info-list">
                                <span>手机号：</span>
                                <span>{{userInfo.phone}}</span>
                            </div>
                            <div class="info-list">
                                <span>邮箱：</span>
                                <span>{{userInfo.email}}</span>
                            </div>
                            <div class="info-list">
                                <span>上级用户：</span>
                                <span>{{userInfo.superiorNames}}</span>
                            </div>
                            <div class="info-list">
                                <span>角色：</span>
                                <span>{{userInfo.roleName}}</span>
                            </div>
                            <div class="info-list">
                                <span>微信号：</span>
                                <img :src="userInfo.wechatQrcode" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ListDetails ref="listDetails" ></ListDetails>
    </div>
</template>

<script>
    import ListDetails from '../../components/ListDetails'
    export default {
        name: 'MailList',
        components: {  ListDetails },
        data() {
            return {
                currentTab: 1,
                currentTask: 1,
                userTree: '',
                selectedUser: '',
                commonContacts: false,
                searchName: '',
                userInfo: '',
                taskInfo: '',
                taskObj: {
                    myResponseTask: [],
                    myCreatedTask: [],
                    myCoordinationTask: []
                },
                messageList: [],
                dataId: '',
                passModuleId: '',
                countFlag: false,
                messageCount: 0,
                messageId: ''
            }   
        },
        methods: {
            convertToPlainText(data) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');
                return doc.body.textContent || "";
            },
            selectTab(type) {
                this.currentTab = type
            },
            selectTask(param) {
                this.currentTask = param
                if(param!=4){
                    this.queryTaskInfo()
                }else{
                    this.queryMessageList()
                }
            },
            queryUserTree() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/serviceProviderUser/addressBook', 
                        params: {
                            name: this.searchName
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.userTree = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            selectUser(id, bool, messageCount) {
                this.selectedUser = id
                this.commonContacts = bool
                this.messageCount = messageCount
                this.queryUserInfo()
                this.queryTaskInfo()
                this.queryMessageList()
            },
            queryUserInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/serviceProviderUser/userInfo', 
                        params: {
                            liaisonId: this.selectedUser
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.userInfo = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryTaskInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/task/list', 
                        params: {
                            type: this.currentTask,
                            liaisonId: this.selectedUser
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.taskInfo = response.data.data
                        if(this.currentTask == 1){
                            this.taskObj.myResponseTask = response.data.data
                        }else if(this.currentTask == 2){
                            this.taskObj.myCreatedTask = response.data.data
                        }else if(this.currentTask == 3){
                            this.taskObj.myCoordinationTask = response.data.data
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            removeCollection(value, flag) {
                event.stopPropagation();
                this.axios(
                    {
                        method:'delete',
                        url:'/api/serviceProviderUser/delLiaison', 
                        params: {
                            liaisonId: value
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryUserTree()
                        if(flag){
                            this.queryUserInfo()
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            addCollection(value) {
                event.stopPropagation();
                this.axios.post('/api/serviceProviderUser/addLiaison', {
                    liaisonId: value,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryUserTree()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            nameChange() {
                this.queryUserTree()
            },
            onSelect(selectedKeys) {
                this.selectedUser = selectedKeys[0]
                this.queryUserInfo()
                this.queryTaskInfo()
                this.queryMessageList()
            },
            queryMessageList() {
                if(this.selectedUser == ''){
                    this.$message.error('请选择对应联系人')
                    return false
                }
                this.axios(
                    {
                        method:'get',
                        url:'/api/comment/messageList', 
                        params: {
                            liaisonId: this.selectedUser
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.messageList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            viewDel(moduleId, dataId, id) {
                this.messageId = id
                this.dataId = dataId
                this.passModuleId = moduleId
                this.countFlag = true
                this.updateReadState(id)
                this.$refs.listDetails.getPassModuleId(this.passModuleId)
                this.$refs.listDetails.changeAffairBoolValue()
                this.$refs.listDetails.getDataIdValue(dataId)
                this.$refs.listDetails.queryDetailsData()
                this.$refs.listDetails.queryTabList()
                this.$refs.listDetails.setCurrentTab()
                this.$refs.listDetails.queryUserList()
            },
            updateReadState(id) {
                this.axios.post('/api/comment/updateRead', {
                    id: id,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryMessageList()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            startFetching() {
                this.queryUserTree(); // 立即请求一次数据
                this.intervalId = setInterval(
                    this.queryUserTree, 
                5000); // 每 5 秒请求一次
            },
        },
        mounted: function() {
            this.startFetching()
            this.queryTaskInfo()
            this.queryUserInfo()
            document.onclick = (e)=> {
                if(e.target.className == 'affair-title'){
                    if(e.target.attributes.moduleid.value!=''){
                        this.passModuleId = e.target.attributes.moduleid.value
                    }else{
                        this.passModuleId = this.moduleId
                    }
                    this.viewDel(this.passModuleId,e.target.attributes['1']['nodeValue'],this.messageId)
                }
                if(this.countFlag){
                    setTimeout(()=>{
                        this.$refs.listDetails.changePersonBoxBoolValue()
                        this.$refs.listDetails.changeTagsBoolValue()
                    },200)
                }
                this.$forceUpdate();
            }
        },
        beforeDestroy() {
            clearInterval(this.intervalId);
        },
    }
</script>

<style scoped lang="less">
    .mailList{
        display: flex;
        width: 100%;
        height: 100%;
        background: #fff;
        .group-list{
            width: 240px;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            height: 100%;
            padding: 14px 0;
            display: flex;
            flex-direction: column;
            .group-tab{
                height: 42px;
                border-bottom: 1px solid rgba(229, 229, 229, 1);
                i{
                    display: inline-block;
                    line-height: 25px;
                    margin-top: 14px;
                    font-size: 18px;
                }
                i.active{
                    border-bottom:3px solid rgba(58, 220, 255, 1);
                    color: rgba(58, 220, 255, 1);
                }
            }
            .user-list{
                flex: 1;
                overflow-y: auto;
                .name-item{
                    
                    .name-title{
                        color: rgba(158, 172, 196, 1);
                        font-size: 12px;
                        padding: 12px 0 12px 24px;
                    }
                    .name-box{
                        height: 48px;
                        line-height: 48px;
                        padding: 0 24px;
                        position: relative;
                        span.name-abbreviation{
                            display: inline-block;
                            width: 24px;
                            height: 24px;
                            border-radius: 12px;
                            line-height: 24px;
                            text-align: center;
                            color: rgba(255, 255, 255, 1);
                            background: rgba(58, 220, 255, 1);
                            margin-right: 8px;
                            font-size: 12px;
                        }
                        .name-img{
                            width: 24px;
                            border-radius: 12px;
                            margin-right: 8px;
                            height: 24px;
                        }
                        span.name-title{
                            color: rgba(18, 18, 18, 1);
                            font-size: 14px;
                            margin-right: 8px;
                        }
                        .remove-icon{
                            float: right;
                            margin-top: 16px;
                            display: none;
                        }
                        .remove-icon:hover{
                            color: #F72F2F;
                        }
                        .add-icon{
                            float: right;
                            margin-top: 16px;
                            display: none;
                        }
                        .add-icon:hover{
                            color: rgb(58, 220, 255);
                        }
                    }
                    .active{
                        span:nth-child(2){
                            color: rgb(58, 220, 255);
                        }
                    }
                    .name-box:hover{
                        background: rgba(240, 242, 243, 0.5);
                        cursor: pointer;
                        .remove-icon{
                            display: inline-block;
                        }
                        .add-icon{
                            display: inline-block;
                        }
                    }
                }
                
            }
        }
        .right-content{
            flex: 1;
            .content-detail{
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                .user-info{
                    height: 250px;
                    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
                    width: 100%;
                    .user-info-head{
                        height: 200px;
                        background: url('../../assets/img/mail-banner.jpg') no-repeat;
                        background-size: 100% 100%;
                        position: relative;
                        width: 100%;
                        z-index: 10;
                    }
                    .user-info-foot{
                        height: 50px;
                        padding: 11px 24px 0 128px;
                        color: rgba(158, 172, 196, 1);
                        i{
                            margin-right: 8px;
                        }
                        .line{
                            margin: 0 16px;
                        }
                    }
                }
                .task-list{
                    flex: 1;
                    background: rgba(240, 242, 243, 1);
                    padding: 16px 16px 24px;
                    overflow-y: auto;
                    .task-content{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        .task-info{
                            flex: 1;
                            height: 100%;
                            background: #fff;
                            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
                            padding: 16px 24px;
                            .task-head{
                                height: 30px;
                                border-bottom: 1px solid rgba(229, 229, 229, 1);
                                span{
                                    color: rgba(158, 172, 196, 1);
                                    font-size: 13px;
                                    margin-right: 32px;
                                    display: inline-block;
                                    cursor: pointer;
                                    padding-bottom: 6px;
                                }
                                span.active{
                                    color: rgba(58, 220, 255, 1);
                                    font-weight: bold;
                                    border-bottom: 3px solid rgba(58, 220, 255, 1);
                                }
                            }
                            .task-body{
                                flex: 1;
                                overflow-y: auto;
                                .my-task,.created-task,.coordination-task{
                                    .item-task{
                                        padding: 17px 0 15px 0;
                                        border-bottom: 1px solid #ECECEC;
                                        .task-state{
                                            width: 72px;
                                            height: 26px;
                                            display: inline-block;
                                            text-align: center;
                                            float: left;
                                            line-height: 26px;
                                            background: rgba(24, 144, 255, 0.1);
                                            color: rgba(24, 144, 255, 1);
                                            font-size: 13px;
                                        }
                                        .task-title{
                                            color: rgba(18, 18, 18, 1);
                                            font-size: 13px;
                                            margin-left: 49px;
                                        }
                                        .relation-name{
                                            color: rgba(158, 172, 196, 1);
                                            font-size: 13px;
                                        }
                                        .right-item{
                                            display: inline-block;
                                            float: right;
                                            // padding-top: 5px;
                                            .time{
                                                color: rgba(158, 172, 196, 1);
                                                font-size: 12px;
                                                margin-right: 27px;
                                            }
                                            .tag-list{
                                                display: inline-block;
                                                color: rgba(18, 18, 18, 1);
                                                font-size: 13px;
                                            }
                                        }
                                    }
                                }
                                .receive-msg{
                                    .receive-item{
                                        display: flex;
                                        height: 84px;
                                        padding: 17px 0 0 0;
                                        border-bottom: 1px solid rgba(229, 229, 229, 1);
                                        .receive-name1{
                                            display: inline-block;
                                            width: 72px;
                                            height: 26px;
                                            color: 13px;
                                            background: rgba(24, 144, 255, 0.1);
                                            line-height: 26px;
                                            text-align: center;
                                            color: rgba(24, 144, 255, 1);
                                            margin-right: 50px;
                                        }
                                        .receive-name2{
                                            display: inline-block;
                                            width: 72px;
                                            height: 26px;
                                            color: 13px;
                                            background: rgba(246, 76, 79, 0.1);
                                            line-height: 26px;
                                            text-align: center;
                                            color: rgba(246, 76, 79, 1);
                                            margin-right: 50px;
                                        }
                                        .receive-content{
                                            flex: 1;
                                            .receive-con1{
                                                color: rgba(18, 18, 18, 1);
                                                font-size: 13px;
                                                // white-space: nowrap; /* 不换行 */
                                                overflow: hidden; /* 隐藏超出部分 */
                                                text-overflow: ellipsis; /* 显示省略号 */
                                                height: 20px;
                                                cursor: pointer;
                                                word-break: break-all;
                                            }
                                            .receive-con2{
                                                margin-top: 8px;
                                                span:nth-child(1){
                                                    color: rgba(158, 172, 196, 1);
                                                    font-size: 12px;
                                                }
                                                span:nth-child(2){
                                                    color: rgba(158, 172, 196, 1);
                                                    font-size: 12px;
                                                    float: right;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .personal-info{
                            width: 316px;
                            height: 356px;
                            background: #fff;
                            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
                            margin-left: 16px;
                            padding: 0  24px 24px;
                            .info-list{
                                display: block;
                                clear: both;
                                padding: 24px 0 0;
                                span:nth-child(1){
                                    color: rgba(158, 172, 196, 1);
                                    font-size: 13px;
                                    width: 90px;
                                    display: inline-block;
                                    float: left;
                                }
                                span:nth-child(2){
                                    color: rgba(18, 18, 18, 1);
                                    font-size: 13px;
                                }
                                img{
                                    width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            
        }
        .number-unread{
            position: absolute;
            background: rgba(246, 76, 79, 1);
            color: #fff;
            font-size: 12px;
            height: 18px;
            line-height: 16px;
            min-width: 18px;
            right: 15px;
            top: 15px;
            border-radius: 9px;
            text-align: center;
            padding: 0 4px;
        }
    }
    .unread-number{
        position: absolute;
        background: rgba(246, 76, 79, 1);
        color: #fff;
        font-size: 12px;
        height: 18px;
        line-height: 16px;
        min-width: 18px;
        right: -20px;
        top: 0px;
        border-radius: 9px;
        text-align: center;
        padding: 0 4px;
        display: inline-block;
    }
</style>